export enum NodeType {
  Node = 'Node',
  Sticky = 'Sticky',
}
